import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { QuestionState } from './question.types';

const initialState: QuestionState = {
  name: '',
  phone: '',
  policyChecked: false,
};

export const questionSlice = createSlice({
  name: 'question',
  initialState,
  reducers: {
    setQuestionName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setQuestionPhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload;
    },
    toggleQuestionPolicy: (state) => {
      state.policyChecked = !state.policyChecked;
    },

    clearQuestion: (state) => {
      state.name = '';
      state.phone = '';
      state.policyChecked = false;
    },
  },
});

export const {
  setQuestionName,
  setQuestionPhone,
  toggleQuestionPolicy,

  clearQuestion,
} = questionSlice.actions;

export const selectQuestion = (state: RootState) => state.question;

export const questionReducer = questionSlice.reducer;
